module.exports = __webpack_public_path__ + "media/images/file-alt-regular-955174367e73e1ad6d6888de164a5df5.svg";